<template>
  <div class="medicalDiagnosis">
    <div class="filter">
      <div class="filter_item">
        <el-input
          class="filter_item_input"
          v-model="form.search"
          placeholder="疾病名称/医保编码"
          prefix-icon="el-icon-search"
          clearable>
        </el-input>
      </div>
      <div class="filter_action">
        <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
        <el-button icon="el-icon-refresh" @click="reset">重置</el-button>
      </div>
    </div>

    <div class="table_list">
      <el-table
        :data="list"
        border
        style="width: 100%">
        <el-table-column prop="recode" label="疾病分类" min-width="140"></el-table-column>
        <el-table-column prop="code" label="国家医保编码" min-width="140"></el-table-column>
        <el-table-column prop="name" label="疾病名称" min-width="220"></el-table-column>
        <el-table-column prop="ybScope" label="医保属性" width="120">
          <template slot-scope="scope">
            <span v-if="scope.row.ybScope === 1">可统筹</span>
            <span v-if="scope.row.ybScope === 2">仅个账</span>
            <span v-if="scope.row.ybScope === 3">不可刷医保</span>
          </template>
        </el-table-column>
        <el-table-column prop="enableStatus" label="状态" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.enableStatus === 1">启用</span>
            <span v-if="scope.row.enableStatus === 2">禁用</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120" fixed="right">
          <template v-if="nowDeptId == '0' || nowDeptId == '-1'" slot-scope="scope">
            <el-button type="text" @click="toEdit(scope.row)">编辑</el-button>
            <el-button type="text" @click="statusChange(scope.row)">{{ scope.row.enableStatus === 1 ? '禁用' : '启用' }}</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="table_pagination">
      <el-pagination
        :current-page="form.pageNo"
        :page-size="form.pageSize"
        :total="total"
        layout="total, prev, pager, next"
        @current-change="listPageNoChange">
      </el-pagination>
    </div>

    <el-dialog
      title="编辑"
      :visible.sync="editMap.visible"
      width="500px"
      :before-close="editClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false">
      <div class="edit_content">
        <el-form ref="editForm" :model="editMap.form" :rules="editMap.rules" label-width="110px">
          <el-form-item label="疾病分类:">
            <div>{{ editMap.form.recode }}</div>
          </el-form-item>
          <el-form-item label="国家医保编码:">
            <div>{{ editMap.form.code }}</div>
          </el-form-item>
          <el-form-item label="疾病名称:">
            <div>{{ editMap.form.name }}</div>
          </el-form-item>
          <el-form-item label="医保属性:" prop="ybScope">
            <el-radio-group v-model="editMap.form.ybScope">
              <el-radio :label="1">可统筹</el-radio>
              <el-radio :label="2">仅个账</el-radio>
              <el-radio :label="3">不可刷医保</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="edit_footer">
        <el-button @click="editClose">取 消</el-button>
        <el-button type="primary" @click="editConfirm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import req from '@/utils/request'

  export default {
    name: 'medicalDiagnosis',
    data() {
      return {
        nowDeptId: '',
        form: {
          search: '',
          pageNo: 1,
          pageSize: 10
        },
        list: [],
        total: 0,
        editMap: {
          visible: false,
          rules: {
            ybScope: [
              { required: true, message: '请选择医保属性', trigger: 'change' }
            ]
          },
          form: {
            diagnoseId: '',
            recode: '',
            code: '',
            name: '',
            ybScope: null
          }
        }
      }
    },
    created () {
      this.nowDeptId = sessionStorage.getItem('deptId')
      this.getList()
    },
    methods: {
      async getList () {
        const res = await req.post('/yb/diagnose/page', {
          search: this.form.search,
          currentPage: this.form.pageNo,
          pageSize: this.form.pageSize
        })
        if (res.code === 200) {
          this.list = res.rows
          this.total = res.total
        }
      },
      listPageNoChange (pageNo) {
        this.form.pageNo = pageNo
        this.getList()
      },
      search () {
        this.form.pageNo = 1
        this.getList()
      },
      reset () {
        this.form = {
          search: '',
          pageNo: 1,
          pageSize: 10
        }
        this.getList()
      },
      toEdit (row) {
        this.editMap.form.diagnoseId = row.diagnoseId
        this.editMap.form.recode = row.recode
        this.editMap.form.code = row.code
        this.editMap.form.name = row.name
        this.editMap.form.ybScope = row.ybScope
        this.editMap.visible = true
      },
      statusChange (row) {
        this.$confirm(`确认${row.enableStatus === 1 ? '禁用' : '启用'}该诊断?`, '操作确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          const res = await req.post('/yb/diagnose/editEnableStatus', {
            diagnoseId: row.diagnoseId,
            enableStatus: row.enableStatus === 1 ? 2 : 1
          })
          if (res.code === 200) {
            this.$message.success('操作成功')
            this.getList()
          }
        }).catch(() => {})

      },
      editClose () {
        this.editMap.visible = false
        this.editMap.form = {
          diagnoseId: '',
          recode: '',
          code: '',
          name: '',
          ybScope: null
        }
        this.$refs.editForm.clearValidate()
      },
      editConfirm () {
        this.$refs.editForm.validate(async (valid) => {
          if (valid) {
            const res = await req.post('/yb/diagnose/editYbScope', {
              diagnoseId: this.editMap.form.diagnoseId,
              ybScope: this.editMap.form.ybScope
            })
            if (res.code === 200) {
              this.$message.success('保存成功')
              this.editClose()
              this.getList()
            }
          }
        })
      }
    }
  }
</script>

<style lang="less" scoped>
  .medicalDiagnosis {
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
  }

  .filter {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px;
    width: 100%;
  }

  .filter_item {
    width: 220px;
  }

  .filter_item_input {
    width: 100%;
  }

  .table_list {
    margin: 12px 0 0 0;
    width: 100%;
  }

  .table_pagination {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin: 12px 0 0 0;
    width: 100%;
  }

</style>
